import React from 'react';
import TwoThreeRows from "../layouts/TwoThreeRows/TwoThreeRows";
import BlankComponent from "../components/BlankComponent/BlankComponent";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import { NavLink } from 'react-router-dom';
import store from "../store";
import {Helmet} from "react-helmet";

const chargesAndPayments = () => {
  return (

    <TwoThreeRows
      rows={3}

      mainPanel={
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/charges-payments-heading.html"
        />
      }

      contentPanel1={
        <BlankComponent>
          <div className="two-three-rows__content">
              <Helmet>
                  {
                      store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                          return row.rowTitle === "Ship" ? row.sections.map((section) => {
                              return section.title === "Charges & Payments" ? <meta name="description" content={section.content['seo-description']}/> : null
                          }) : null
                      }) : null
                  }
              </Helmet>
            <div className="two-three-rows__image-container">
              <img src="./assets/ship/ChargesAndPayments/credit.jpg" alt="" className="cover-image"/>
            </div>
            <div className="two-three-rows__text">
              <h2 className="two-three-rows__item-title">Credit Cards</h2>
              <div className="two-three-rows__description">
                <ul>
                    <li>Visa</li>
                    <li>MasterCard</li>
                    <li>Discover</li>
                    <li>American Express</li>
                </ul>
              </div>
            </div>
          </div>
        </BlankComponent>
      }

      contentPanel2={<div className="two-three-rows__content"></div>}

      contentPanel3={<div className="two-three-rows__content"></div>}

      footerPanel={
          <div className="wrapper wrapper--two-three-rows-box">
              <h2 className="two-three-rows__item-title">Additional Payment Options</h2>
              <div className="two-three-rows__box-container">
                  <h5>Billable Accounts</h5>
                  <p>In order to add billing to your existing account, please complete our <NavLink to="/manage/forms-and-applications/update-account-form/">Update Account
                      Form</NavLink>. To maintain
                      billable account privileges, you must pay in accordance with the payment terms set forth on the invoice.
                      Southwest Cargo retains the right to refuse or remove billable account privileges at any time.</p>
                  <p>In order to establish a billable account, please visit our <NavLink to="/ship/apply">application</NavLink> to complete the online
                      application.</p>
                  <h5>Available Forms of Payment For Invoicing</h5>
                  <p>To pay your invoice we only accept wire or ACH.</p>
                  <h5>Declared Value Coverage</h5>
              <p>At Southwest Cargo, we consider each item you ship valuable, and we treat it that way. At times, you
                may need to ship items that require additional coverage. And we can assist you in purchasing declared
                value coverage for your precious cargo. For more information, refer to our <NavLink to="/learn/declared-value">declared value page</NavLink>.</p>
              <h5>International Payments</h5>
              <p>All shipments originating in an international point of origin must be prepaid utilizing a Southwest
                Cargo Master Account. We currently do not accept cash, check, credit card, or collect as a form of
                payment.</p>
            </div>
        </div>
      }
    />
  )
};

export default chargesAndPayments;



// WEBPACK FOOTER //
// ./src/pages/ChargesAndPayments.js